import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Heey-o , I am <span className="blue">Nemanja Vucetic </span>
            currently located in <span className="blue">Belgrade, Serbia </span>.
            <br />

            <br/>
            I'm always open to feedback and ready to learn from more experienced colleagues to improve my skills.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Creating content for Social Media
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Podcasts
            </li>
            <li className="about-activity">
              <ImPointRight /> Washing Dishes
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
          It’s not a bug; it’s an undocumented feature.
          </p>
          <footer className="blockquote-footer">Anonymous</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
